import { ConfiguratorUI } from './configurator-ui';
import { LocationService } from './location/location.service';

export default class Configurator {

	static getUID() {
		return `conf-${new Date().getTime()}`;
	}

	constructor(node) {
		this.node = node;
		this.optionsContainer = node.querySelector('[data-configurator-options]');
		this.optionContainer = node.querySelectorAll('[data-configurator-option]');
		this.kjosulContainer = node.querySelector('[data-configurator-model]');
		this.getProductData((productData) => {
			this.productData = productData;
			this.init();
		});
	}

	getProductData(callback) {
		const url = `/api/configurator/products/configurationconfigurables/${productSheet.idDoc}?state=true`;
		fetch(url).then((response) => {
			if (response.ok) {
				return response.json();
			} else {
				throw new Error('Something went wrong');
			}
		}).then((data) => {
			if (typeof callback === 'function') {
				callback(data);
			}
		}).catch((error) => {
			console.log('Configurator.getProductData.error', error);
		});
	}

	init() {
		const node = this.node;
		const kjosulContainer = this.kjosulContainer;
		kjosulContainer.id = Configurator.getUID();
		let initialCode;
		const validConfigurations = productSheet.codes;
		const productData = this.productData;
		const configurator = this.configurator = new KJ.CalligarisConfigurator(kjosulContainer.id, {
			assetsBaseUrl: '/docs/assets/conf.1.3', // productSheet.conf.ASSETS_PATH, // path to assets folder
			INVALID_CONFIGURATION: this.getInvalidConfiguration(), // what to do when requesting an invalid configuration
		});

		this.configurator.addObserver('3DViewReady', function() {
			var event = new Event('configurator3DViewReady');
			window.dispatchEvent(event);
		});

		const configuratorUI = this.configuratorUI = new ConfiguratorUI(node, productData, configurator);
		// console.log('Configurator.initialCode', initialCode || validConfigurations[0]);
		if (validConfigurations) {
			const param = decodeURI(LocationService.get('c'));
			// console.log('param', param, validConfigurations);
			if (param) {
				initialCode = validConfigurations.reduce((p, c) => {
					return p || (param.indexOf(c) !== -1 ? param : null);
				}, undefined);
			}
		}
		// initialCode = decodeURI(LocationService.get('c'));
		initialCode = initialCode || validConfigurations[0];
		// console.log('initialCode', initialCode, 'validConfigurations', validConfigurations);
		configurator.setActualProduct(initialCode, validConfigurations).then((viewDescription) => {
			// console.log('Configurator.setActualProduct', viewDescription, configurator);
			if (configurator.model &&
				configurator.model.actualComposition &&
				configurator.model.actualComposition.configurations &&
				configurator.model.actualComposition.configurations[0].product.is2D) {
				node.classList.add('is-2d');
			} else {
				node.classList.add('is-3d');
			}
			if (viewDescription != undefined) {
				configuratorUI.setViewDescription(viewDescription);
				configuratorUI.init();
			}
		}, (error) => {
			console.log('Configurator.setActualProduct', error, 'initialCode', initialCode, 'validConfigurations', validConfigurations);
		});
	}

	getInvalidConfiguration() {
		const dbType = productSheet.typeDB;
		this.dbType = dbType;
		let setting;
		switch (dbType) {
			case 'artcal':
				setting = 'error';
				break;
			case 'divcal':
				setting = 'return_first';
				break;
			case 'divd3':
				setting = 'return_first';
				break;
		}
		return setting;
	}

	static init() {
		Configurator.items = Array.prototype.slice.call(document.querySelectorAll('[data-configurator]')).map((element, id) => {
			return new Configurator(element, id);
		});
		// debug__('Configurator: ', Configurator.items);
	}
}
